import { AttributeModalType } from 'Types/Tasks.types'

interface SubmitModalState {
    confidenceLevel: string | undefined
    comment: string | undefined
}

type SubmitModalAction =
    | { type: AttributeModalType.Radio | undefined; payload: string | undefined }
    | { type: AttributeModalType.TextArea | undefined; payload: string | undefined }

// Reducer for submitModal state
export const submitModalReducer = (
    state: SubmitModalState,
    action: SubmitModalAction
): SubmitModalState => {
    switch (action.type) {
        case AttributeModalType.Radio:
            return { ...state, confidenceLevel: action.payload }
        case AttributeModalType.TextArea:
            return { ...state, comment: action.payload }
        default:
            return state
    }
}
